export const ensureTrailingSlash = path => {
  if (path) {
    if (!path.endsWith("/")) {
      path += "/";
    }
  }
  return path;
};

const S3_DOCUMENT_HOST_PATTERN =
  /^origo-reclamation-api-[a-z0-9-]+\.s3\.[a-z0-9-]+\.amazonaws\.com$/i;

export const isSafeDocumentUrl = value => {
  if (typeof value !== "string" || !value.trim()) {
    return false;
  }

  try {
    const url = new URL(value);
    const isS3Url =
      url.protocol === "https:" && S3_DOCUMENT_HOST_PATTERN.test(url.hostname);

    return isS3Url;
  } catch (error) {
    return false;
  }
};

export const getUrlParamsFromObject = targetObject =>
  Object.keys(targetObject || {}).reduce((acc, key) => {
    const value = targetObject[key];
    if (value) {
      const param = `${key}=${value}`;
      acc = acc.length ? `${acc}&${param}` : param;
    }
    return acc;
  }, "");

export const getObjectFromUrlParams = urlParams => {
  // sanity
  if (urlParams == null || urlParams.length === 0) {
    return {};
  }

  if (urlParams.startsWith("?")) {
    urlParams = urlParams.substring(1);
  }

  return urlParams.split("&").reduce((acc, param) => {
    const keyValue = param.split("=");
    const key = keyValue[0];
    const value = keyValue[1];
    acc[key] = value;
    return acc;
  }, {});
};
